module.exports = __webpack_public_path__ + "img/product-icon_1.73133a4f.png";